import { ReactElement } from 'react'

const ServerError = (): ReactElement => {
  return (
    <div>Oops! There was an error retrieving the data from the server.</div>
  )
}

export default ServerError
